module.exports = __webpack_public_path__ + "c0249ca62ac5cf8168a57e3f1f5c4dcf.png";